import { User } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import {
  Freelancer,
  PrivateUserInfo,
  Stakeholder,
  UserRole,
} from "@freetech/models/user";
import { db } from "@freetech/models/db";

export const getAuthUserProfile = async (
  currentUser: User,
  role: UserRole
): Promise<PrivateUserInfo | Freelancer | Stakeholder | null> => {
  let userData;
  if (role === "freelancer") {
    const freelancerRef = doc(db.freelancers, currentUser.uid);
    const freelancerSnap = await getDoc(freelancerRef);
    userData = freelancerSnap.data();
  } else if (role === "stakeholder") {
    const stakeholderRef = doc(db.stakeholders, currentUser.uid);
    const stakeholderSnap = await getDoc(stakeholderRef);
    userData = stakeholderSnap.data();
  } else {
    const privateUserRef = doc(db.users, currentUser.uid);
    const privateUserSnap = await getDoc(privateUserRef);
    userData = privateUserSnap.data();
  }

  if (!userData) {
    return null;
  }

  return {
    ...userData,
    needsOnboarding: userData.needsOnboarding,
    disabled: userData?.disabled || false,
    profilePicture: userData.profilePicture,
  };
};
